export default "__VITE_ASSET__BFptSA$1__"